import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { PHBHPLayoutPackageService } from "ph-bhp-feature-packages/ph-bhp-layout-package/public_api";
import { PHBHPFeaturePackageElearningService } from "../ph-bhp-feature-package-elearning.service";
import { SopDetail, SopStep } from "../Models";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import {
  CdkDragDrop,
  transferArrayItem,
  moveItemInArray,
  CdkDropList,
} from "@angular/cdk/drag-drop";
import { sop } from "./sop";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "lib-ph-bhp-startpuzzle",
  templateUrl: "./ph-bhp-startpuzzle.component.html",
  styleUrls: ["./ph-bhp-startpuzzle.component.css"],
})
export class PHBHPStartpuzzleComponent implements OnInit {
  sopStepsList: any = [];
  shuffledsteps = [];
  arrangedList: Array<Array<any>> = [];
  IdList: any = [];
  completed_steps = 0;
  drag_counts = 0;
  sopStep: SopStep = sop();
  sopDetails: SopDetail = {} as SopDetail;
  modalRef: BsModalRef;

  @ViewChild("template") template: TemplateRef<any>;
  @Input() sopId: number;
  @Input() userData: any;
  @Output() action = new EventEmitter();
  Result;
  interval: any;
  timer: number;
  bestScore: number;
  myScore;
  startminutes = 0;
  display;
  totalseconds;
  ngOnInit() {
    if (this.sopId) {
      this.service.getbestScoreDetails(this.sopId).subscribe((res: any) => {
        this.bestScore = res;
      });

      this.service.getSOPById(this.sopId).subscribe((res: SopDetail) => {
        this.sopDetails = res;
        this.sopStepsList = this.sopDetails.sopStepsVersions[0].stepsJsonFile;
        this.shuffledsteps = this.shuffle(this.sopStepsList);
        JSON.parse(this.sopStepsList).forEach((arrangedItems) => {
          this.arrangedList.push([
            { stepId: arrangedItems.stepId },
            { stepImage: arrangedItems.stepCards[0].stepImage },
            { stepTitle: arrangedItems.stepCards[0].stepTittle },
          ]);
        });
      });
    }
    this.display = document.querySelector("#time");
    this.startTimer(this.startminutes, this.display);
  }

  constructor(
    public layoutService: PHBHPLayoutPackageService,
    private service: PHBHPFeaturePackageElearningService,
    private modalService: BsModalService,
    private translate: TranslateService
  ) { }

  startTimer(duration, display) {
    let timer = duration,
      minutes,
      seconds;
    this.interval = setInterval(function () {
      let minutes1 = (timer / 60).toString();
      let seconds1 = (timer % 60).toString();
      minutes = parseInt(minutes1, 10);
      seconds = parseInt(seconds1, 10);
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      display.textContent = minutes + ":" + seconds;
      this.totalseconds = minutes * 60 + seconds;
      if (++timer < 0) {
        timer = duration;
      }
    }, 1000);
  }

  shuffle(shufflearray) {
    var shufflearrayNew = JSON.parse(shufflearray);
    var m = shufflearrayNew.length,
      temp,
      i;
    while (m) {
      i = Math.floor(Math.random() * m--);
      temp = shufflearrayNew[m];
      shufflearrayNew[m] = shufflearrayNew[i];
      shufflearrayNew[i] = temp;
    }
    return shufflearrayNew;
  }

  emitData(key: any, value: any = null) {
    this.action.emit({ key: key, val: value });
  }

  addId(i) {
    this.IdList.push("cdk-drop-list-" + (i + 1));
    return 2 + i;
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.container != event.previousContainer) {
      this.drag_counts = this.drag_counts + 1;
      if (event.container.data.length == 3) {
        const currentStepId = event.item.element.nativeElement.id;
        if (this.isDropEventMatchStep(event)) {
          const currentIndex = this.shuffledsteps.findIndex(sf => sf.stepId == currentStepId);
          transferArrayItem(event.previousContainer.data,
            event.container.data,
            currentIndex,
            0);
          this.completed_steps = this.completed_steps + 1;
          if (this.completed_steps == this.arrangedList.length) {
            clearInterval(this.interval);
            this.calculateBestScore()
            this.openModal(this.template)
          }
        }
        else {
          this.layoutService.showError(
            this.layoutService.translateText("E_LEARNING.STEP_MISMATCH")
          );
        }
      }
    }
  }

  calculateBestScore() {
    let convertseconds = this.display.textContent.split(":");
    this.totalseconds = +convertseconds[0] * 60 + +convertseconds[1];
    if (this.totalseconds == 0) {
      this.totalseconds = 1;
    }
    this.myScore =
      (this.completed_steps / this.drag_counts) *
      (60 / this.totalseconds) *
      100;
    this.myScore = Number(this.myScore.toFixed());
    var data = {
      sopId: this.sopId,
      moves: this.drag_counts,
      puzzleScore: this.myScore,
      timeTaken: this.totalseconds,
      createdBy: this.userData.userId,
    };
    this.service.savebestScoreDetails(data).subscribe((res: any) => { });
  }

  openModal(template: TemplateRef<any>) {
    this.myScore = Number(this.myScore.toFixed());
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "w-420" })
    );
  }

  replayPuzzle() {
    for (var i = 0; i < this.arrangedList.length; i++) {
      this.arrangedList[i].splice(0, 1);
    }
    this.shuffledsteps = this.shuffle(this.sopStepsList);
    this.completed_steps = 0;
    this.drag_counts = 0;
    (this.startminutes = 0),
      this.service.getbestScoreDetails(this.sopId).subscribe((res: any) => {
        this.bestScore = res;
      });
    this.display = document.querySelector("#time");
    this.startTimer(this.startminutes, this.display);
  }

  private isDropEventMatchStep(event: CdkDragDrop<any[]>): boolean {
    const findedStep = this.shuffledsteps.find(sf => sf.stepId == (+event.item.element.nativeElement.id));
    const originStep: StepContainer = {
      stepId: findedStep.stepId,
      stepImage: findedStep.stepCards[0].stepImage,
      stepTitle: findedStep.stepCards[0].stepTittle,
    };
    const targetStep: StepContainer = {
      stepId: event.container.data[0].stepId,
      stepImage: event.container.data[1].stepImage,
      stepTitle: event.container.data[2].stepTitle,
    };
    return (
      this.isMatchByStepId(originStep, targetStep) ||
      this.isMatchByStepTitleAndImage(originStep, targetStep)
    );
  }

  private isMatchByStepId(
    originStep: StepContainer,
    targetStep: StepContainer
  ): boolean {
    return originStep.stepId == targetStep.stepId;
  }

  private isMatchByStepTitleAndImage(
    originStep: StepContainer,
    targetStep: StepContainer
  ): boolean {
    let originStepTitleTranslation = this.layoutService
      .translateText(originStep.stepTitle)
      .toString()
      .toLowerCase()
    let targetStepTitleTranslation = this.layoutService
      .translateText(targetStep.stepTitle)
      .toString()
      .toLowerCase()
    return (
      originStep.stepImage == targetStep.stepImage &&
      originStepTitleTranslation == targetStepTitleTranslation
    );
  }
}

interface StepContainer {
  stepId: number;
  stepTitle: string;
  stepImage: string;
}
